module.exports = __webpack_public_path__ + "static/img/390_phase_function_Paper_PointsHejduk_Prediction.f4c8301.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/390_phase_function_Paper_PointsHejduk_Prediction.png
// module id = D1lQ
// module chunks = 0